module.exports = __webpack_public_path__ + "img/quizzz-2.f8513e52.jpg";